export const DEPOSIT_RETURN_ACCOUNT = {
  depositReturnBankName: '국민은행',
  depositReturnBankAccount: '111122222333333',
  depositReturnBankHolder: '예금주',
  isDepositReturned: false,
}

export const EMPTY_DEPOSIT_RETURN_ACCOUNT = {
  depositReturnBankName: null,
  depositReturnBankAccount: null,
  depositReturnBankHolder: null,
  isDepositReturned: false,
}
